const AUTH0_ADMIN_RESET_USER_PASSWORD = '/dbconnections/change_password';
const CONECTION = 'zosi-users';
const CLIENTS = '/clients';
const NAMESPACE = 'https://zosilearning.com/';
const GET_LIBRARY_DETAILS = '/library';

export {
  AUTH0_ADMIN_RESET_USER_PASSWORD,
  CONECTION,
  CLIENTS,
  NAMESPACE,
  GET_LIBRARY_DETAILS,
};
